var map = {
	"./ViasatAmerican.jpg": 1148,
	"./ViasatFotball.jpg": 1149,
	"./ViasatMotorNO.jpg": 1150,
	"./ViasatSportFI.jpg": 1151,
	"./Viasatgolf.png": 1152,
	"./ViasportNO.png": 1153,
	"./tv3sportdk.jpeg": 1154,
	"./viaplay.png": 1060,
	"./viasat-fotboll.jpg": 1155,
	"./viasat-golf.jpg": 1156,
	"./viasat-hockey.jpg": 1157,
	"./viasat-motor.jpg": 1158,
	"./viasat-sport.jpg": 1061
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1114;


//////////////////
// WEBPACK FOOTER
// ./assets/logos ^\.\/.*$
// module id = 1114
// module chunks = 0 1